// Auth adapter — JWT-based. Pro náhradu Microsoft MSAL tokenem
// stačí vyměnit těla funkcí verifyPin a nactiTechnikyProLogin.

import axios from 'axios';
import { pole } from './utils';

const KEYS = {
  token: 'entsol_token',
  role:  'entsol_role',
  jmeno: 'entsol_jmeno',
};

const API = process.env.REACT_APP_API_URL || '/api';

export function getStoredToken() {
  return sessionStorage.getItem(KEYS.token);
}

export function getStoredRole() {
  return sessionStorage.getItem(KEYS.role);
}

export function getStoredJmeno() {
  return sessionStorage.getItem(KEYS.jmeno);
}

export function storeAuth(token, role, jmeno) {
  sessionStorage.setItem(KEYS.token, token);
  sessionStorage.setItem(KEYS.role, role);
  sessionStorage.setItem(KEYS.jmeno, jmeno);
}

export function clearStoredRole() {
  Object.values(KEYS).forEach(k => sessionStorage.removeItem(k));
}

export function isTokenExpired() {
  const token = getStoredToken();
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() / 1000 > payload.exp;
  } catch {
    return true;
  }
}

// Dekóduje payload JWT tokenu ze sessionStorage -> { role, jmeno, exp } | null.
export function getTokenPayload() {
  const token = getStoredToken();
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

export async function nactiTechnikyProLogin() {
  const res = await axios.get(`${API}/auth/technici`);
  return pole(res.data);
}

export async function verifyPin(role, pin, technikId = null) {
  const res = await axios.post(`${API}/auth/verify-pin`, {
    role,
    pin,
    technik_id: technikId,
  });
  return res.data; // { token, role, jmeno }
}

// Smí přihlášený uživatel být řešitelem a vyjíždět (G1)? Starší token bez příznaku: technik a admin ano, dispečer ne.
export function muzeResit(payload = getTokenPayload()) {
  if (!payload) return false;
  return payload.muze_resit ?? payload.role !== 'dispecer';
}

// Dispečer, který zároveň vyjíždí: má práva dispečera a navíc Moje tikety, Frontu a Vzít si.
export function jeDispecerTechnik(payload = getTokenPayload()) {
  return payload?.role === 'dispecer' && muzeResit(payload);
}
